import * as React from "react";
import {
    AppBar,
    Container,
    Grid,
    Link as ExternalLink,
    List,
    ListItem,
    styled,
    Typography,
} from "@mui/material";
import { AppConfig, Routes } from "config";
import { Link } from "#common/Link";

const FooterLink = styled(Link)(({ theme }) => {
    return {
        color: theme.palette.primary.contrastText,
    };
});

const FooterExternalLink = styled(ExternalLink)(({ theme }) => {
    return {
        color: theme.palette.primary.contrastText,
    };
});

export const Footer: React.FC = () => {
    return (
        <AppBar
            component={"footer"}
            position={"relative"}
            // color={"inherit"}
            sx={{
                top: "auto",
                paddingTop: "5rem",
                bottom: 0,
                boxShadow: `0px -2px 4px -1px rgb(0 0 0 / 20%), 0px -4px 5px 0px rgb(0 0 0 / 14%), 0px -1px 10px 0px rgb(0 0 0 / 12%)`,
            }}
        >
            <Grid
                container
                sx={
                    {
                        // backgroundColor: (theme) => theme.palette.background.paper
                    }
                }
            >
                <Grid item xs={12}>
                    <Container maxWidth={"lg"}>
                        <Grid container>
                            <Grid item xs={6}>
                                <Typography variant="subtitle1">
                                    {AppConfig.name}
                                </Typography>
                                <List component="nav" dense>
                                    <ListItem>
                                        <FooterLink to={Routes.gdpr.path}>
                                            General Data Protection Regulation
                                        </FooterLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterLink to={Routes.sitemap.path}>
                                            Documentation
                                        </FooterLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterLink to={Routes.about.path}>
                                            About
                                        </FooterLink>
                                    </ListItem>
                                </List>
                                <Typography variant="subtitle1">
                                    INODE
                                </Typography>
                                <List component="nav" dense>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={
                                                "http://testbed.inode.igd.fraunhofer.de:18000/"
                                            }
                                            target="_blank"
                                        >
                                            CORDIS SPARQL Portal
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={
                                                "http://testbed.inode.igd.fraunhofer.de:18006/"
                                            }
                                            target="_blank"
                                        >
                                            SDSS SPARQL Portal
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={
                                                "http://testbed.inode.igd.fraunhofer.de:18005/"
                                            }
                                            target="_blank"
                                        >
                                            OncoMX SPARQL Portal
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={
                                                "http://www.inode-project.eu:18081/test/galaxies.html"
                                            }
                                            target="_blank"
                                        >
                                            DORA The Explorer (Galaxy
                                            exploration)
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={"http://www.inode-project.eu"}
                                            target="_blank"
                                        >
                                            INODE Project
                                        </FooterExternalLink>
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle1">
                                    Consortium
                                </Typography>
                                <List component="nav" dense>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={"https://igd.fraunhofer.de"}
                                            target="_blank"
                                        >
                                            Fraunhofer Institute for Computer
                                            Graphics Research IGD
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={
                                                "https://www.zhaw.ch/en/university/"
                                            }
                                            target="_blank"
                                        >
                                            Zurich University of Applied
                                            Sciences
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={
                                                "https://www.athena-innovation.gr/en/home"
                                            }
                                            target="_blank"
                                        >
                                            ATHENA Research
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={
                                                "http://www.sirisacademic.com/"
                                            }
                                            target="_blank"
                                        >
                                            SIRIS Academic
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={"http://www.cnrs.fr/"}
                                            target="_blank"
                                        >
                                            French National Centre for
                                            Scientific Research (CNRS)
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={"https://www.unibz.it/"}
                                            target="_blank"
                                        >
                                            Free University of Bozen-Bolzano
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={"https://www.sib.swiss/"}
                                            target="_blank"
                                        >
                                            SIB Swiss Institute of
                                            Bioinformatics
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={"https://www.infili.com/"}
                                            target="_blank"
                                        >
                                            Infili Technologies Private Company
                                        </FooterExternalLink>
                                    </ListItem>
                                    <ListItem>
                                        <FooterExternalLink
                                            href={"https://www.mpg.de/en"}
                                            target="_blank"
                                        >
                                            Max-Planck Institute for
                                            Extraterrestrial Physics
                                        </FooterExternalLink>
                                    </ListItem>
                                </List>
                            </Grid>
                        </Grid>
                    </Container>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sx={{
                        textAlign: "center",
                    }}
                >
                    OpenDataDialog 3.0, version {VERSION}, &copy; Fraunhofer
                    Institute for Computer Graphics Research IGD,{" "}
                    {LASTCOMMITDATETIME}
                </Grid>
            </Grid>
        </AppBar>
    );
};
